import { Controller } from "stimulus";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";
import EnrollmentChannel from "../entrypoints/src/admin/channels/enrollment_channel";
import CreditCardFormValidation from "../entrypoints/src/admin/components/credit_card_form_validation";
import sweet_alert from "../entrypoints/src/admin/utilities/sweet_alert";

const creditCardActions = {
  'credit-card/opened': {
    text: 'formulário aberto', exec() {}
  },
  'credit-card/filled': {
    text: 'formulário preenchido', exec() {}
  },
  'credit-card/submitted': {
    text: 'formulário encaminhado', exec() {}
  },
  'credit-card/created': {
    text: 'cartão de crédito adicionado', exec() {
      sweet_alert.fire({
        text: 'Cartão de crédito atualizado pelo cliente',
      }).then(() => {
        document.querySelector('turbo-frame#turbo-modal').reload();
      });
    }
  }
};

export default class extends Controller {
  static targets = ['strategyCreditCard', 'maturityDay'];

  connect() {
    if (this.element.querySelectorAll('.payment-types').length == 0)
      return;

    let _self = this;
    this.$btnSave = this.element.querySelector(".btn#save");
    this.enrollmentId = this.element.dataset.enrollmentId;
    this.initCreditCardFormValidation();
    $('turbo-frame#turbo-modal .select2').select2({ escapeMarkup: (markup) => markup });
    !!this.maturityDayTarget && $(this.maturityDayTarget).on('select2:select', () => {
      let $messages = _self.element.querySelector('#warning-messages');
      if (_self.maturityDayTarget.value == _self.maturityDayTarget.dataset.currentValue) {
        $messages.innerHTML = '';
        return;
      }

      $messages.innerHTML = '<div class="warning-message mb-10 border border-yellow-700 bg-yellow-100 text-yellow-700 rounded-lg shadow-sm px-4 py-2"><i class="fas fa-exclamation-triangle"></i> Para manter a cobrança agrupada, todos as faturas pendentes relacionadas, terão seus vencimentos alterados</div>';
    })
    this.strategyCreditCardTarget.addEventListener('change', () => {
      let isForm = this.strategyCreditCardTarget.selectedOptions[0].dataset.value == 'form';
      this.element.querySelectorAll('#credit-card-form [name^="credit_card"]').forEach(($el) => {
        $el.disabled = !isForm
      });
      this.$btnSave.classList.toggle('disabled', isForm);
    });
    this.$btnSave.addEventListener('click', (ev) => {
      if (this.$btnSave.classList.contains('disabled'))
        ev.preventDefault();
    });
    this.subscription();
  }

  initCreditCardFormValidation() {
    if (!this.element.querySelector('#credit-card-form'))
      return;

    let _this = this;
    this.formValidation = new CreditCardFormValidation(this.element, {
      afterValidate(valid) {
        _this.$btnSave.classList.toggle('disabled', !valid);
      }
    });
  }

  subscription() {
    let _this = this;
    this.enrollmentChannel = EnrollmentChannel.create(this.enrollmentId, {
      received(data) {
        document.querySelector('.status').innerHTML = _this.dictionary(data.status).text;
        _this.dictionary(data.status).exec(data);
      },

      connected() {
        console.debug('conectado');
        document.querySelector('.status').innerHTML = 'conectado';
      }
    });

    return this.enrollmentChannel;
  }

  dictionary(status) {
    return creditCardActions[status];
  }

  disconnect() {
    AjaxLoader.hide();
    this.enrollmentChannel.close();
  }
}